(() => {
  if (window.wisemanQuickSizeInitialized) return;
  window.wisemanQuickSizeInitialized = true;

  const rootSelector = '[data-quick-size-root]';

  const closeQuickSize = (root) => {
    if (!root) return;

    root.classList.remove('is-open');

    const toggle = root.querySelector('[data-quick-size-toggle]');
    const panel = root.querySelector('[data-quick-size-panel]');

    toggle?.setAttribute('aria-expanded', 'false');
    if (panel) panel.hidden = true;
  };

  const openQuickSize = (root) => {
    if (!root) return;

    document.querySelectorAll(`${rootSelector}.is-open`).forEach((openRoot) => {
      if (openRoot !== root) closeQuickSize(openRoot);
    });

    root.classList.add('is-open');

    const toggle = root.querySelector('[data-quick-size-toggle]');
    const panel = root.querySelector('[data-quick-size-panel]');

    toggle?.setAttribute('aria-expanded', 'true');
    if (panel) panel.hidden = false;
  };

  const toggleQuickSize = (root) => {
    if (root?.classList.contains('is-open')) {
      closeQuickSize(root);
    } else {
      openQuickSize(root);
    }
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-quick-size-toggle]');

    if (toggle) {
      event.preventDefault();
      toggleQuickSize(toggle.closest(rootSelector));
      return;
    }

    const sizeOption = event.target.closest('[data-quick-size-option]');

    if (sizeOption) {
      event.preventDefault();

      if (sizeOption.disabled) return;

      const root = sizeOption.closest(rootSelector);
      const variantInput = root?.querySelector('[data-quick-size-variant-input]');
      const submitButton = root?.querySelector('[data-quick-size-submit]');
      const submitLabel = root?.querySelector('[data-quick-size-submit-label]');
      const variantId = sizeOption.dataset.variantId;

      if (!root || !variantInput || !submitButton || !variantId) return;

      root.querySelectorAll('[data-quick-size-option]').forEach((option) => {
        const selected = option === sizeOption;

        option.classList.toggle('is-selected', selected);
        option.setAttribute('aria-pressed', String(selected));
      });

      variantInput.value = variantId;
      variantInput.disabled = false;

      submitButton.disabled = false;
      submitButton.setAttribute('aria-disabled', 'false');

      if (submitLabel) {
        submitLabel.textContent = 'AGREGAR AL CARRITO';
      }

      return;
    }


    if (!event.target.closest(rootSelector)) {
      document.querySelectorAll(`${rootSelector}.is-open`).forEach(closeQuickSize);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll(`${rootSelector}.is-open`).forEach((root) => {
      const toggle = root.querySelector('[data-quick-size-toggle]');

      closeQuickSize(root);
      toggle?.focus();
    });
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target
      ?.querySelectorAll(`${rootSelector}.is-open`)
      .forEach(closeQuickSize);
  });
})();
